import React, { PropTypes } from 'react'

const TestimonialName = (props) => {
  return (
    <div className="row">
      <div className="col-sm-offset-6 col-sm-6">
        <h2>{ props.name }</h2>
      </div>
    </div>
  )
}

export default TestimonialName;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/TestimonialName.jsx
 **/